<template>
  <div class="btn-menu" @click="() => $events.$emit('OPEN_DRAWER')" :style="styles">
    <div/>
    <div/>
    <div/>
  </div>
</template>

<script>
export default {
  name: 'btn-menu',
  props: {
    color: {
      type: String,
      default: 'var(--secondary)'
    }
  },
  computed: {
    styles () {
      return {
        '--color': this.color
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-menu {
  padding: 15px 10px;
  cursor: pointer;

  div {
    width: 23px;
    height: 3px;
    margin: 5px 0;
    background-color: var(--color);

    &:last-of-type {
      width: 15px;
    }
  }
}
</style>
